import { insertNode, selectionType } from '@lyearn/lygo-blocks';
import { EditorView } from '@lyearn/lygo-core';

const onMentionButtonClick = (editorView?: EditorView) => {
  if (!editorView) {
    return;
  }
  const position = editorView.state.selection.$anchor.pos;
  insertNode(editorView, selectionType.TEXT, '@', position);
  editorView.focus();
};

export default onMentionButtonClick;
